import { Location } from 'history';

const getSearchQueryParamForLink = (browserLocation: Location<unknown>, linkingSymbol: string) => {
  const { search } = browserLocation;
  const query = new URLSearchParams(search);
  const searchQueryTerm = query.get('query');
  if (searchQueryTerm) {
    return `${linkingSymbol}query=${searchQueryTerm}`;
  }
  return '';
};

export default getSearchQueryParamForLink;
